export const SET_IS_ADDING_TASK = 'SET_IS_ADDING_TASK';
export const SET_TASKS = 'SET_TASKS';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const FILTER_TASKS = 'FILTER_TASKS';
